import { loader } from 'graphql.macro'

export default function clientImport ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./clientImport.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { id: variables.id })
}
